import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableHead from './../../component/table/table/TableHead';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import Utils from './../../component/utils/utils';
import DatePicker from './../../component/datePicker';
import AdHocViewEnum from './adHocViewEnum';
import Select from './../../component/select';

class TableView extends Component {
    // START private methods
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        var searchParams = this._createSearchParamsObject();
        Service.fetchAdHocReport(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

    _callServiceDownloadFile() {
        var searchParams = this._createSearchParamsObject();
        Service.downloadAdHocReport(searchParams, this.viewType);
    }

    _createSearchParamsObject(page) {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        searchParams.searchStatus = this.statusDropdownValue;
        searchParams.groupBy = this.groupByValue;

        return searchParams;
    }
    // END private methods

    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Ad Hoc Total Shipments by Status",
        pagingMetadata: [],
        responseTableData: {},
        firstColumnName : "Date",
        firstColumnKey : "createdDate",
        showMask: false
    }

    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.viewType = AdHocViewEnum.SHIPMENTBYSTATUS;
        this.statusDropdownValue = "";
        this.groupByValue = "";
        this.tableHeaderColumnList = [
            { columnName: this.state.firstColumnName, key: this.state.firstColumnKey},
            { columnName: "Account Id", key: "changedByAccountId"},
            { columnName: "Total Shipments", key: "shipments"},
        ]
    }

    componentDidMount () {
        var fetchEventForResultData = Service.getEventSignal(this.viewType);
        fetchEventForResultData.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }

    onStartDateFieldChange = (value) => {
        this.createdDateStart = value;
    };

    onEndDateFieldChange = (value) => {
        this.createdDateEnd = value;
    };

    onSearchFieldChange = (value) => {
        this.searchInputFieldValue = value;
    };

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    downloadFileAction = () => {
        this._callServiceDownloadFile();
    };

    handleTotalShipmentDropdownChange = (event) => {
        this.statusDropdownValue = event.target.value;
    };

    handleGroupByChange = (event) => {
        var elementValue = event.target.value;
        this.groupByValue = elementValue;
        if (elementValue === "groupByDate") {
            this.tableHeaderColumnList = [
                {columnName: "Date", key: "createdDate"},
                {columnName: "Total Shipments", key: "shipments"},
            ]
        } else if (elementValue === "") {
            this.tableHeaderColumnList = [
                {columnName: "Date", key: "createdDate"},
                { columnName: "Account Id", key: "changedByAccountId"},
                { columnName: "Total Shipments", key: "shipments"}
            ]
        } else {
            this.tableHeaderColumnList = [
                { columnName: "Account Id", key: "changedByAccountId"},
                { columnName: "Total Shipments", key: "shipments"},
            ]
        }
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        downloadFileAction = {this.downloadFileAction}
                        type = "adHocReport"
                    >
                        <Select name="groupByDropdown" className={"packages-status-dropdown"}
                                controlFunc={this.handleGroupByChange}
                                options = {Utils.groupByOptions}
                        />
                        <Select name="statusDropdown" className={"packages-status-dropdown"}
                                controlFunc={this.handleTotalShipmentDropdownChange}
                                options = {Utils.shipmentStatusDropdownOptions}
                        />
                        <DatePicker
                            fieldId = "adHocShipmentByStatusStartDatePicker"
                            placeHolderText = "Created Start Date"
                            onChange = {this.onStartDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "adHocShipmentByStatusEndDatePicker"
                            placeHolderText = "Created End Date"
                            onChange = {this.onEndDateFieldChange}
                            fieldType = "endDate"
                        />
                    </TableSearchHeader>
                   <TableHead
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                   />
                   <TableBody
                       tableDataResults = {this.state.responseTableData.results}
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                       showMask = {this.state.showMask}
                   >

                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;
